module.exports = __webpack_public_path__ + "static/media/varify-badge-step3.99fe2584.png";